module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"next":"Jipii! Seuraavan viikon ruokalistat ovat jo saatavilla. Selaa niitä vaihtamalla päivää."},"en":{"next":"Juhuu! Next week\u0027s menus are already available. You may browse them by changing the day of week."}}')
  delete Component.options._Ctor
}
